import React from "react";
import { Link, useLocation } from "react-router-dom";

function isItemActive(item, location) {
  if (!item) return false;
  if (typeof item.active === "function") return Boolean(item.active(location));
  if (typeof item.active === "boolean") return item.active;
  const to = String(item.to || "");
  if (!to) return false;
  const [path, hash] = to.split("#");
  if (path && path !== location.pathname) return false;
  if (hash) return location.hash === `#${hash}`;
  return path === location.pathname;
}

export default function MobileQuickNav({ items = [], className = "" }) {
  const location = useLocation();
  const visibleItems = React.useMemo(
    () => items.filter((item) => item && (item.to || typeof item.onClick === "function")),
    [items]
  );

  if (!visibleItems.length) return null;

  return (
    <nav
      className={`mobile-quick-nav ${className}`.trim()}
      aria-label="Быстрые действия"
      style={{ "--mobile-quick-count": Math.min(3, Math.max(1, visibleItems.length)) }}
    >
      {visibleItems.map((item, index) => {
        const active = isItemActive(item, location);
        const content = (
          <>
            <span className="mobile-quick-nav__icon" aria-hidden="true">{item.icon || "•"}</span>
            <span className="mobile-quick-nav__label">{item.label}</span>
          </>
        );
        const classes = `mobile-quick-nav__item${active ? " is-active" : ""}${item.accent ? ` is-${item.accent}` : ""}`;
        const key = item.key || item.to || item.label || `quick-${index}`;

        if (typeof item.onClick === "function") {
          return (
            <button key={key} type="button" className={classes} onClick={item.onClick}>
              {content}
            </button>
          );
        }

        return (
          <Link key={key} to={item.to} className={classes}>
            {content}
          </Link>
        );
      })}
    </nav>
  );
}
